// @flow

/**
 * Module dependencies.
 */

import { chain, get, isNull } from 'lodash';
import { getUrlBasedOnLanguage } from 'core/utils/routes';
import { pages } from 'core/entities';
import config from 'config';

/**
 * Variables constants.
 */

const basePath = get(config, 'basePath');
const languages = get(config, 'i18n.whitelist');
const routes = Object.keys(pages);

/**
 * Export `baseUrl`.
 */

export const baseUrl = isNull(basePath) ? '' : basePath;

/**
 * Export `routerPaths`.
 */

export const routerPaths = chain(routes)
  .map(key => languages.map(language => getUrlBasedOnLanguage(key, language)))
  .flatten()
  .value();



// WEBPACK FOOTER //
// ../src/core/utils/sitemap.js